export default (initialValue: string) => {
    const value = parseFloat(initialValue);

    return !Number.isNaN(value) ? value : null;
};
